import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const METERS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('METERS');
export const METERS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	METERS_CRUD_ACTION_CONSTANTS
);
